import { render, staticRenderFns } from "./ImageFormItem.vue?vue&type=template&id=0bba60c0&scoped=true&"
import script from "./ImageFormItem.vue?vue&type=script&lang=js&"
export * from "./ImageFormItem.vue?vue&type=script&lang=js&"
import style0 from "./ImageFormItem.vue?vue&type=style&index=0&id=0bba60c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba60c0",
  null
  
)

export default component.exports